import { fiveCapabilities } from '@/mocks/aboutData';
import { img, readdy } from '@/utils/images';
import { useState } from 'react';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function FiveCapabilities() {
  const [activeIndex, setActiveIndex] = useState(0);

  const active = fiveCapabilities[activeIndex];

  return (
    <section className="relative bg-brand-gray py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06]">
        <img
          src={readdy('five-cap-bg-v2')}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="px-6 md:px-10">
        <div className="max-w-7xl mx-auto">

          <ScrollReveal variant="fade-up">
            <div className="text-center mb-14">
              <p className="text-brand-brown text-sm tracking-widest mb-3 font-medium">企业实力</p>
              <h2 className="text-3xl md:text-4xl font-bold text-brand-deep leading-tight">
                五大核心能力，构筑品牌基石
              </h2>
              <p className="text-gray-400 text-sm mt-3 max-w-xl mx-auto">
                产品研发、品牌推广、营销策划、培训赋能、售后服务，五位一体支撑品牌持续发展
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
            <ScrollReveal variant="fade-right">
              <div className="space-y-4">
                {fiveCapabilities.map((cap, index) => (
                  <button
                    key={cap.title}
                    onClick={() => setActiveIndex(index)}
                    className={`w-full text-left p-5 rounded-2xl border transition-all duration-300 cursor-pointer ${
                      index === activeIndex
                        ? 'bg-white border-brand-cream shadow-sm'
                        : 'bg-transparent border-transparent hover:bg-white/60'
                    }`}
                  >
                    <div className="flex items-center gap-4">
                      <div
                        className={`w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0 transition-colors duration-300 ${
                          index === activeIndex
                            ? 'bg-brand-deep text-white'
                            : 'bg-white text-brand-brown'
                        }`}
                      >
                        <i className={`${cap.icon} text-xl`} />
                      </div>
                      <div>
                        <h3
                          className={`text-base font-semibold transition-colors duration-300 ${
                            index === activeIndex ? 'text-brand-deep' : 'text-gray-500'
                          }`}
                        >
                          {cap.title}
                        </h3>
                        <p className="text-gray-400 text-xs mt-0.5">
                          {cap.desc.slice(0, 30)}...
                        </p>
                      </div>
                      <div className="ml-auto">
                        <i
                          className={`transition-colors duration-300 ${
                            index === activeIndex
                              ? 'ri-arrow-right-s-line text-brand-deep'
                              : 'ri-add-line text-gray-300'
                          }`}
                        />
                      </div>
                    </div>
                  </button>
                ))}
              </div>
            </ScrollReveal>

            <ScrollReveal variant="fade-left" delay={150}>
              <div className="bg-white rounded-2xl p-6 md:p-8 border border-brand-light/40">
                <div className="w-16 h-16 flex items-center justify-center rounded-xl bg-brand-deep text-white mb-6">
                  <i className={`${active.icon} text-2xl`} />
                </div>
                <h3 className="text-xl font-bold text-brand-deep mb-3">{active.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-6">{active.desc}</p>
                <div className="grid grid-cols-2 gap-3">
                  {active.features.map((feat) => (
                    <div
                      key={feat}
                      className="flex items-center gap-2 text-sm text-gray-600"
                    >
                      <div className="w-5 h-5 flex items-center justify-center rounded-full bg-brand-light flex-shrink-0">
                        <i className="ri-check-line text-xs text-brand-brown" />
                      </div>
                      <span className="text-xs">{feat}</span>
                    </div>
                  ))}
                </div>
              </div>
            </ScrollReveal>
          </div>

        </div>
      </div>
    </section>
  );
}